import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './index.css'
import { perfMonitor } from './utils/performance'

// Track app initialization
perfMonitor.start('app-init')

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2, // Retry failed requests twice
      staleTime: 30 * 1000, // 30 seconds - data stays fresh
      gcTime: 5 * 60 * 1000, // 5 minutes - cache retained in memory (formerly cacheTime)
      refetchInterval: false, // Don't auto-refetch by default (override per query)
      refetchOnMount: true, // Refetch when component mounts if data is stale
      refetchOnReconnect: true, // Refetch when connection is restored
    },
    mutations: {
      retry: 1, // Retry mutations once on failure
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)

// End app initialization tracking
perfMonitor.end('app-init')

// Log performance summary after 5 seconds (in development)
if (import.meta.env.DEV) {
  setTimeout(() => {
    perfMonitor.printSummary()
  }, 5000)
}
